<template>
  <el-container class="CleanRecordForTest">
   <el-header class="header">
  <div class="header-container">
    <div class="title-box">
      <h1>测试卡密管理</h1>
      <p v-if="isBound">支持清理测试卡密，按月统计，请及时处理。</p>
    </div>
    <el-button
      v-if="isBound"
      type="danger"
      size="large"
      @click="confirmClean"
      :loading="loading"
      class="clean-btn"
    >
      清理所有测试卡密
    </el-button>
  </div>
</el-header>


    <el-main>
      <div v-if="!isBound" class="bind-panel">
        <el-card class="bind-card" shadow="hover">
          <h2>绑定测试账号</h2>
          <p style="margin-bottom: 12px; color: #666">请输入你的游戏星球账号进行绑定</p>
          <el-input
            v-model="bindPhone"
            placeholder="请输入游戏星球账号"
            clearable
            maxlength="11"
            size="large"
            style="margin-bottom: 20px; width: 100%;"
          ></el-input>
          <el-button type="primary" size="large" @click="bindAccounts">绑定账号</el-button>
        </el-card>
      </div>

      <div v-else>
        <!-- <el-button type="danger" size="large" @click="confirmClean" :loading="loading" style="margin-bottom: 20px;">
          清理所有测试卡密
        </el-button> -->

        <el-input
          v-model="searchQuery"
          placeholder="搜索卡密"
          @input="onSearch"
          clearable
          prefix-icon="el-icon-search"
          style="margin-bottom: 20px;"
        ></el-input>

        <el-table
          :data="records"
          style="width: 100%;"
          :default-sort="{ prop: 'creationTime', order: 'descending' }"
          border
        >
          <el-table-column prop="code" label="兑换码" width="400" />
          <el-table-column prop="category" label="类别" width="100" />
          <el-table-column prop="game" label="所属游戏" width="150" />
          <el-table-column prop="creator" label="制卡人" width="120" />
          <el-table-column prop="creationTime" label="制卡时间" sortable width="180" />
          <el-table-column prop="usageTime" label="使用时间" sortable width="180" />
          <el-table-column prop="user" label="使用用户" width="120" />
        </el-table>

        <el-empty v-if="records.length === 0" description="没有记录可显示" />

        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="totalCount"
          :page-size="pageSize"
          v-model:current-page="currentPage"
          @current-change="onPageChange"
          style="margin-top: 20px; text-align: center;"
        />

        <el-card class="summary-card" shadow="hover" style="margin-top: 30px;">
          <p>
            你名下的测试账号：<strong>{{ bindAccount }}</strong>，
            累计使用 <strong>豪华版 {{ countDeluxe }}</strong> 张（核计产值：<strong>{{ valueDeluxe }} 元</strong>），
            终极版 <strong>{{ countUltimate }}</strong> 张（核计产值：<strong>{{ valueUltimate }} 元</strong>），
            累计拿货成本共：<strong>{{ totalCost }} 元</strong>。
          </p>
          <p style="margin-top: 8px; color: #e53935;">
            请在每月最后一天前及时清理测试卡密，以免被统计核算进拿货价格里。
            已被核算进拿货价格并支付款项的，责任自负，不予退款。
          </p>
        </el-card>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../axios';
import { ElMessage, ElMessageBox } from '@/plugins/tdesignElementAdapter';

export default {
  name: 'CleanRecordForTest',
  data() {
    return {
      records: [],
      searchQuery: '',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      isBound: false,
      bindPhone: '',
      bindAccount: '',
      countDeluxe: 0,
      countUltimate: 0,
      valueDeluxe: 0,
      valueUltimate: 0,
      totalCost: 0,
      username: '未登录用户'
    };
  },
  created() {
    this.checkBinding();
  },
  methods: {
    async checkBinding() {
      try {
        const token = localStorage.getItem('user-token');
        const res = await axios.post('/index.php?action=checkGamePlanetBinding', { token });
        if (res.data.binded) {
          this.isBound = true;
          this.bindAccount = res.data.bindGamePlanet || '';
          this.username = res.data.bindGamePlanet || '测试账号';
          this.fetchRecords();
          this.fetchStatistics();
        } else {
          this.isBound = false;
        }
      } catch (e) {
        this.isBound = false;
      }
    },
    async fetchRecords() {
      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.post('/index.php?action=generateRecordsFortest', {
          token,
          search: this.searchQuery,
          page: this.currentPage,
          pageSize: this.pageSize
        });

        if (response.data.code === 200) {
          this.records = response.data.records || [];
          this.totalCount = response.data.totalCount || 0;
          this.currentPage = response.data.currentPage || 1;
        } else {
          ElMessage.error('加载数据失败');
        }
      } catch (error) {
        console.error('fetchRecords error:', error);
        this.records = [];
        ElMessage.error('加载数据失败');
      }
    },
    async fetchStatistics() {
      try {
        const token = localStorage.getItem('user-token');
        const res = await axios.post('/index.php?action=getTestCodeStatistics', { token });
        if (res.data.code === 200) {
          this.countDeluxe = res.data.countDeluxe;
          this.countUltimate = res.data.countUltimate;
          this.valueDeluxe = res.data.valueDeluxe;
          this.valueUltimate = res.data.valueUltimate;
          this.totalCost = res.data.totalCost;
        }
      } catch (e) {
        console.warn('fetchStatistics error:', e);
      }
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchRecords();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchRecords();
    },
    confirmClean() {
      ElMessageBox.confirm(
        '此操作将永久删除所有测试卡密，是否继续？',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => this.cleanTestCodes())
        .catch(() => {
          ElMessage.info('已取消清理操作');
        });
    },
    async cleanTestCodes() {
      this.loading = true;
      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.post('/index.php?action=cleanTestCodes', {
          token
        });

        if (response.data.success) {
          ElMessage.success(response.data.message || '测试卡密已清理');
          this.fetchRecords();
          this.fetchStatistics();
        } else {
          ElMessage.error(response.data.message || '清理失败');
        }
      } catch (error) {
        ElMessage.error('请求失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    async bindAccounts() {
      console.log('绑定按钮被点击'); // ✅ 检查事件是否进来了
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.bindPhone || !phoneRegex.test(this.bindPhone)) {
        ElMessage.error('请输入有效的中国大陆手机号');
        return;
      }

      try {
        const token = localStorage.getItem('user-token');
        const response = await axios.post('/index.php?action=bindGamePlanetAccount', {
          token,
          phone: this.bindPhone
        });

        if (response.data.code === 200) {
          ElMessage.success('绑定成功！');
          this.isBound = true;
          this.fetchRecords();
          this.fetchStatistics();
        } else {
          ElMessage.error(response.data.message || '绑定失败');
        }
      } catch (e) {
        ElMessage.error('绑定失败，请稍后再试');
      }
    }
  }
};
</script>

<style scoped>


.header-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.title-box h1 {
  margin: 0;
}

.title-box p {
  font-size: 14px;
  color: #666;
  margin: 4px 0 0 0;
}

/* 响应式调整：桌面端横向排布 */
@media (min-width: 768px) {
  .header-container {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .clean-btn {
    margin-top: 0 !important;
  }
}

/* 保证移动端按钮下移且宽度适中 */
.clean-btn {
  align-self: flex-start;
  margin-top: 10px;
}





.CleanRecordForTest {
  padding: 20px;
}

.header h1 {
  margin-bottom: 6px;
}

.header p {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.el-table th,
.el-table td {
  white-space: nowrap;
}

.summary-card {
  font-size: 15px;
  line-height: 1.8;
}

.bind-panel {
  display: flex;
  justify-content: center;
  padding-top: 60px;
}

.bind-card {
  max-width: 400px;
  padding: 30px;
  text-align: center;
  background-color: #f9f9f9;
}


</style>
